import React, { useState, useCallback, useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FloatingActions } from "@/components/layout/FloatingActions";
import { EnquiryDialog } from "@/components/EnquiryDialog";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Contact from "@/pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AppShell() {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const openEnquiry = useCallback(() => setEnquiryOpen(true), []);
  const closeEnquiry = useCallback((v) => setEnquiryOpen(v), []);

  return (
    <>
      <ScrollToTop />
      <Header onOpenEnquiry={openEnquiry} />
      <main>
        <Routes>
          <Route path="/" element={<Home onOpenEnquiry={openEnquiry} />} />
          <Route
            path="/about"
            element={<About onOpenEnquiry={openEnquiry} />}
          />
          <Route
            path="/products"
            element={<Products onOpenEnquiry={openEnquiry} />}
          />
          <Route
            path="/products/:slug"
            element={<ProductDetail onOpenEnquiry={openEnquiry} />}
          />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="*"
            element={<Home onOpenEnquiry={openEnquiry} />}
          />
        </Routes>
      </main>
      <Footer />
      <FloatingActions onOpenChat={openEnquiry} />
      <EnquiryDialog open={enquiryOpen} onOpenChange={closeEnquiry} />
      <Toaster
        richColors
        position="top-center"
        toastOptions={{
          style: {
            fontFamily: "Manrope, system-ui",
          },
        }}
      />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </div>
  );
}
